import Checkbox from 'components/Checkbox';
import { FC } from 'react';
import { SubGroupType } from './accounts.types';
import clsx from 'clsx';
import DisabledToolTip from './DisabledToolTip';

export interface SubGroupProps extends SubGroupType {
  onClick?: () => void;
  checked?: boolean;
  disabled?: boolean;
  showDisabledTooltip?: boolean;
}

const SubGroup: FC<SubGroupProps> = ({
  id,
  name,
  onClick = undefined,
  checked,
  disabled,
  showDisabledTooltip = false,
}) => {
  return (
    <DisabledToolTip
      className={clsx(
        'relative flex w-full items-center gap-6 rounded px-4 py-2.5',
        {
          'cursor-pointer': onClick && !disabled,
          'bg-background-base-surface-3 text-content-base-default': !disabled,
          'cursor-not-allowed bg-input-background-disabled text-content-base-subdued ring-1 ring-stroke-base-default':
            disabled,
        },
      )}
      show={!!disabled && showDisabledTooltip}
      {...(!disabled ? { onClick } : {})}
    >
      {onClick && <Checkbox checked={checked} />}
      <p>{id}</p>
      <p>{name}</p>
    </DisabledToolTip>
  );
};

export default SubGroup;
